import { DatePickerInput } from '#atoms';
import { useFormContext, useWatch } from 'react-hook-form';

const PortfolioLectureTime = ({
  startRegisterName,
  endRegisterName
}: {
  startRegisterName: string;
  endRegisterName: string;
}) => {
  const methods = useFormContext();

  const watchStart = useWatch({
    control: methods.control,
    name: startRegisterName
  });
  const watchEnd = useWatch({
    control: methods.control,
    name: endRegisterName
  });

  return (
    <div className="flex justify-between gap-8 items-center">
      <DatePickerInput
        title="시작일"
        placeholder={'시작일'}
        fullWidth
        onChange={date => {
          methods.setValue(startRegisterName, date);
        }}
        date={watchStart ? new Date(watchStart) : undefined}
      />
      <span>-</span>
      <DatePickerInput
        title="종료일"
        placeholder={'종료일'}
        fullWidth
        onChange={date => {
          methods.setValue(endRegisterName, date);
        }}
        date={watchEnd ? new Date(watchEnd) : undefined}
      />
    </div>
  );
};

export default PortfolioLectureTime;
